// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-dialog .col,.q-menu .col{padding-right:0;padding-left:0}.q-dialog .row,.q-menu .row{margin-right:0;margin-left:0}", ""]);
// Exports
module.exports = exports;
